"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fields = exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reduxForm = require("redux-form");
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _question = _interopRequireDefault(require("cccisd-icons/question4"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var fields = exports.fields = ['username'];
var Form = /*#__PURE__*/function (_React$Component) {
  _inherits(Form, _React$Component);
  function Form() {
    var _this;
    _classCallCheck(this, Form);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Form, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleCancel", function () {
      window.location = '/account/login';
    });
    return _this;
  }
  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        username = _this$props.fields.username,
        handleSubmit = _this$props.handleSubmit,
        submitting = _this$props.submitting,
        isLabelUsername = _this$props.isLabelUsername;
      return /*#__PURE__*/_react["default"].createElement("form", {
        onSubmit: handleSubmit
      }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
        field: username,
        label: isLabelUsername ? /*#__PURE__*/_react["default"].createElement("span", null, "Username\xA0", /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: "Your username is likely the email address associated with your account."
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: "text-primary"
        }, /*#__PURE__*/_react["default"].createElement(_question["default"], null)))) : 'Email',
        autoFocus: true
      }), /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
        className: "btn btn-default",
        title: "Cancel",
        onClick: this.handleCancel,
        style: {
          marginRight: '10px'
        }
      }), /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
        className: "btn btn-primary",
        title: "Submit",
        isLoading: submitting,
        onClick: handleSubmit
      }));
    }
  }]);
  return Form;
}(_react["default"].Component);
_defineProperty(Form, "propTypes", {
  fields: _propTypes["default"].object.isRequired,
  handleSubmit: _propTypes["default"].func.isRequired,
  submitting: _propTypes["default"].bool.isRequired,
  isLabelUsername: _propTypes["default"].bool.isRequired
});
var _default = exports["default"] = (0, _reduxForm.reduxForm)({
  form: 'forgotPasswordForm',
  fields: fields
})(Form);